<template>
	<div class="pages">
		<div class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill"></div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入手机号 / 门店名称..." @handleSearch="handleOffset(0)"></z-search></div>
		</div>
		<!--列表-->
		<div id="list">
			<z-table :offset="params.offset" :count="params.count" :total-count="shopList.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in shopList.list || []">
					<td>{{item.id}}</td>
					<td><img :src="item.logo_url || defaultPic" />
						</z-img-hover>
					</td>
					<td>{{item.name}}</td>
					<td>
						<p>登录账号：{{item.tel}}</p>
						<p>初始密码：123456&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
					</td>
					<td>
						<p>经度：{{item.longitude||'未知'}}</p>
						<p>纬度：{{item. latitude||'未知'}}</p>
					</td>
					<td>{{item.tel}}</td>
					<td>{{item.l_time| momentFmt}}</td>
					<!--<td>门店收银台</td>-->
					<td class="operating">
						<el-popover placement="top" width="200" :ref="'pwd_popover_'+index">
							<div class="z-popover">
								<div>确定要把此门店的POS机密码重置为初始密码123456?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleResetPwd(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-password"></i><span>重置密码</span></a>
						</el-popover>
						<a class="operat-btn" @click="handleQrCode(item)"><i class="icon-code-simple"></i><span>生成付款码</span></a>
						<!--<a class="operat-btn" @click="handleAddBtn(item)"><i class="icon-edit"></i><span>编辑</span></a>-->
						<router-link class="operat-btn" :to="{ name: 'clearInfo' ,query:{shopId:item.id}}"><i class="icon-settlement"></i><span>结算信息</span></router-link>
						<router-link class="operat-btn" :to="{ name: 'shopEdit' ,query:{shopId:item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>删除此门店后与之相关的数据将不会显示并且门店不能恢复哟！继续删除?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDeleteBtn(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
					</td>
				</tr>
				<div slot="operate">
					<router-link class="z-btn z-btn-primary b-r-3" :to="{ name: 'shopEdit'}">添加门店</router-link>
				</div>
			</z-table>

		</div>
		<!--:class="[isPopQr?'show-in':'hide-out']"-->
		<z-popup :showModel="this.isPopQr">
			<div slot="popup-cont" class="popup-cont b-r-5">
				<p class="btn-close fx-align" @click="handleCloseQrcode"><i class="icon-close"></i></p>
				<div class="pic-cont">
					<div id="qrcode"></div>
				</div>
				<!--<div><a class="btn-down">下载</a></div>-->
			</div>
		</z-popup>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	import { OPEN_URL } from '@/config.js'
	export default {
		name: 'ShowManage',
		components: {},
		data() {
			return {
				defaultPic: require('@/assets/img/logo_def.png'),
				columns: ['门店ID', 'logo', '门店名称', 'POS机账号', '门店坐标', '手机号', '最后操作时间', '操作'],
				qrUrl: '', //二维码店铺链接
				isPopQr: false, // 弹出收款码
				qrcode: null,
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',//查询字符串
				}
			}
		},
		mounted() {
			this.initData();
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				shopList: state => state.shopManage.shopList,
				mid: state => state.users.userInfo.mid || null
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.initData();
			},
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
				if(typeof(this.$refs['pwd_popover_' + index]) != "undefined") this.$refs['pwd_popover_' + index][0].doClose();
			},
			//删除门店
			async handleDeleteBtn(id) {
				try{
					await this.deleteShop({id})
					this.initData();
					this.$success('删除成功')
				}catch(e){
					this.$errorMsg('删除失败')
				}
			},
			
			//重置密码
			async handleResetPwd(id) {
				try{
					await this.resetShopPwd({id}) 
					this.initData()
					this.$success('操作成功')
				}catch(e){
					this.$errorMsg('操作失败')
				}
			},
			
			// 生成付款码
			handleQrCode(item) {
				this.isPopQr = true;
				let qrcodeUrl = `${OPEN_URL}/code_pay?mid=${this.mid}&shopId=${item.id}`;
				if(this.qrcode) return this.qrcode.makeCode(qrcodeUrl);

				this.qrcode = this.$qrcodeInit({
					id: 'qrcode',
					text: qrcodeUrl,
					width: 130,
					height: 130
				})
			},
			
			// 关闭付款码
			handleCloseQrcode() {
				this.isPopQr = false;
				// 清除缓存的支付码
				this.qrUrl = '';
			},
			
			//获取门店列表
			async initData() {
				await this.getShopList(this.params)
			},
			...mapActions(['getShopList', 'deleteShop', 'resetShopPwd']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	table img {
		width: 50px;
		height: 50px;
	}
	
	.pages {
		background: #FFFFFF;
		/*border: 1px solid #EBEDEE;*/
    		/*border-bottom: none;*/
		.filter-list {
			padding: 1rem;
		}
	}
	
	.table-cont {
		background: $color-white;
	}
	
	.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	
	table .operating {
		i,
		span {
			width: 68px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// ShopManage.vue?da85ce04